(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["almea-welcome-popup"]) return;
  try {
    
  if (!customElements.get('almea-welcome-popup')) {
    customElements.define(
      'almea-welcome-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.closeButton = this.querySelector('[data-welcome-popup-close]');
          this.status = this.querySelector('[data-welcome-popup-status]')?.dataset.welcomePopupStatus;
          this.storageKey = 'almea-welcome-popup-dismissed-until';
          this.designMode = this.dataset.designMode === 'true';
          this.handleClose = this.close.bind(this);
          this.handleCancel = this.onCancel.bind(this);
          this.handleDialogClick = this.onDialogClick.bind(this);
          this.handleSectionSelect = this.onSectionSelect.bind(this);

          if (!this.dialog || !this.closeButton) return;

          this.closeButton.addEventListener('click', this.handleClose);
          this.dialog.addEventListener('cancel', this.handleCancel);
          this.dialog.addEventListener('click', this.handleDialogClick);
          document.addEventListener('shopify:section:select', this.handleSectionSelect);

          if (this.status === 'success') {
            this.remember(365);
            this.open();
            return;
          }

          if (this.status === 'error' || this.designMode) {
            this.open();
            return;
          }

          if (this.isDismissed()) return;

          const delay = Number.parseInt(this.dataset.delay, 10) || 0;
          this.openTimer = window.setTimeout(() => this.open(), delay);
        }

        disconnectedCallback() {
          window.clearTimeout(this.openTimer);
          this.closeButton?.removeEventListener('click', this.handleClose);
          this.dialog?.removeEventListener('cancel', this.handleCancel);
          this.dialog?.removeEventListener('click', this.handleDialogClick);
          document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        }

        open() {
          if (this.dialog && !this.dialog.open) this.dialog.showModal();
        }

        close() {
          if (!this.designMode) {
            const days = Number.parseInt(this.dataset.reopenDays, 10) || 14;
            this.remember(days);
          }

          if (this.dialog?.open) this.dialog.close();
        }

        onDialogClick(event) {
          if (event.target === this.dialog) this.close();
        }

        onCancel(event) {
          event.preventDefault();
          this.close();
        }

        onSectionSelect(event) {
          if (event.target.contains(this)) this.open();
        }

        isDismissed() {
          try {
            return Number(window.localStorage.getItem(this.storageKey)) > Date.now();
          } catch {
            return false;
          }
        }

        remember(days) {
          try {
            const expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
            window.localStorage.setItem(this.storageKey, String(expiresAt));
          } catch {
            return;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
